import React from "react";
import { Typography, createStyles, makeStyles } from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import clsx from "clsx";

const useStyles = makeStyles((theme) =>
  createStyles({
    textError: {
      color: theme.palette.error.main,
    },
    textOk: {
      [theme.breakpoints.down("sm")]: {
        color: theme.palette.common.white,
        opacity: 0.5,
      },
      [theme.breakpoints.up("sm")]: {
        color: theme.palette.success.main,
        opacity: 0.5,
      },
    },
    textWrapper: {
      "display": "flex",
      "alignItems": "center",
      "margin": theme.spacing(0.5, 0),

      "& svg": {
        paddingRight: theme.spacing(1),
      },
    },
  })
);

type Props = {
  checkLengh: boolean;
  checkLower: boolean;
  checkUpper: boolean;
  checkNumber: boolean;
  checkSpecial: boolean;
  checkConfirmPassword: boolean;
};

function PasswordRules(props: Props) {
  const {
    checkLengh,
    checkUpper,
    checkLower,
    checkNumber,
    checkSpecial,
    checkConfirmPassword,
  } = props;

  const classes = useStyles();
  return (
    <div>
      <Typography
        className={clsx(classes.textWrapper, checkLengh ? classes.textOk : classes.textError)}
        variant="body2"
        align="left"
      >
        {checkLengh ? <CheckCircleOutlineIcon /> : <ErrorOutlineIcon />}A senha deve ter no mínimo 8
        caracteres
      </Typography>
      <Typography
        className={clsx(classes.textWrapper, checkUpper ? classes.textOk : classes.textError)}
        variant="body2"
        align="left"
      >
        {checkUpper ? <CheckCircleOutlineIcon /> : <ErrorOutlineIcon />}A senha deve ter pelo menos
        uma letra maiúscula
      </Typography>
      <Typography
        className={clsx(classes.textWrapper, checkLower ? classes.textOk : classes.textError)}
        variant="body2"
        align="left"
      >
        {checkLower ? <CheckCircleOutlineIcon /> : <ErrorOutlineIcon />}A senha deve ter pelo menos
        uma letra minúscula
      </Typography>
      <Typography
        className={clsx(classes.textWrapper, checkNumber ? classes.textOk : classes.textError)}
        variant="body2"
        align="left"
      >
        {checkNumber ? <CheckCircleOutlineIcon /> : <ErrorOutlineIcon />}A senha deve ter pelo menos
        um número
      </Typography>
      <Typography
        className={clsx(classes.textWrapper, checkSpecial ? classes.textOk : classes.textError)}
        variant="body2"
        align="left"
      >
        {checkSpecial ? <CheckCircleOutlineIcon /> : <ErrorOutlineIcon />}A senha deve ter pelo
        menos um caracter especial
      </Typography>
      <Typography
        className={clsx(
          classes.textWrapper,
          checkConfirmPassword ? classes.textOk : classes.textError
        )}
        variant="body2"
        align="left"
      >
        {checkSpecial ? <CheckCircleOutlineIcon /> : <ErrorOutlineIcon />}As senhas não conferem
      </Typography>
    </div>
  );
}

export default PasswordRules;
